import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { PermissionActions } from "../actions/permissionActions";
import { Permissions } from "../../types";

export default function permissionsReducer(
    state = initialState.permissions,
    action: PermissionActions
): Permissions | null {
    switch (action.type) {
        case types.SET_CAMERA_PERMISSION_DONE:
            return { ...state, haveCameraAccess: action.videoPermissionState };
        case types.SET_LOCATION_PERMISSION_DONE:
            return {
                ...state,
                haveLocationAccess: action.locationPermissionState
            };
        default:
            return state;
    }
}
